import type { MeshPrimitiveNormalizationResult } from '@/plugins/mesh/MeshPrimitiveNormalizer'
import type {
  MeshFormat,
  MeshLoadDiagnostics,
  MeshLoadResult,
  MeshLoadStats,
} from '@/plugins/mesh/types'

function createStats(
  format: MeshFormat,
  normalized: MeshPrimitiveNormalizationResult
): MeshLoadStats {
  let opaqueCount = 0
  let maskCount = 0
  let blendCount = 0
  let triangleCount = 0
  let vertexCount = 0
  const materials = new Set<string>()

  for (const primitive of normalized.primitives) {
    triangleCount += primitive.triangleCount
    vertexCount += primitive.vertexCount
    materials.add(primitive.material.uuid)
    if (primitive.renderClass === 'opaque') opaqueCount += 1
    else if (primitive.renderClass === 'mask') maskCount += 1
    else blendCount += 1
  }

  return {
    format,
    primitiveCount: normalized.primitives.length,
    triangleCount,
    vertexCount,
    materialCount: materials.size,
    opaqueCount,
    maskCount,
    blendCount,
  }
}

/** 将规范化结果封装为带统计和幂等释放能力的 Loader 结果。 */
export function createMeshLoadResult(
  format: MeshFormat,
  normalized: MeshPrimitiveNormalizationResult,
  diagnostics: MeshLoadDiagnostics,
  elapsedMs: number
): MeshLoadResult {
  return {
    root: normalized.root,
    primitives: normalized.primitives,
    format,
    resources: normalized.resources,
    diagnostics,
    boundingBox: normalized.boundingBox,
    sourcePrimitiveMap: normalized.sourcePrimitiveMap,
    report: {
      stats: createStats(format, normalized),
      diagnostics,
      elapsedMs,
    },
    dispose: () => normalized.resources.dispose(),
  }
}
